// extracted by mini-css-extract-plugin
export default {"result":"style_result__1rapr","resultASS":"style_resultASS__7f-y8","img":"style_img__htP+G","btnHolder":"style_btnHolder__+qhk0"};